import { request } from '../../helpers'

export default {
  async retrieveEvent(eventId, { queryParameters = {}, expand = [] } = {}) {
    // return (
    //   await request({
    //     url: `events/${eventId}`,
    //     queryParameters,
    //     expand,
    //     allow404: true,
    //   })
    // ).data

    const response = (await request({ url: `events/${eventId}`, queryParameters, expand, allow404: true }))
    if (response.status === 404)
      return null
    else return response.data
  },
  async getEvents({ queryParameters = {}, expand = [] } = {}) {
    return (
      await request({
        url: 'events',
        queryParameters,
        expand,
      })
    ).data
  },
  async registerForEvent(eventId, { data = {} }) {
    return (
      await request({
        method: 'POST',
        url: `/events/${eventId}/register`,
        data,
      })
    ).data
  },
  async initiatePurchase(eventId, { data = {} }) {
    return (
      await request({
        method: 'POST',
        url: `/events/${eventId}/initiate_purchase`,
        data,
      })
    ).data
  },
  async initiateMembershipPurchase(membershipId, { data = {} } = {}) {
    if (!membershipId) {
      console.warn(
        'API: initiateMembershipPurchase: membershipId is not defined!',
      )
      return
    }
    return (
      await request({
        method: 'POST',
        url: `memberships/${membershipId}/initiate_purchase`,
        data,
      })
    ).data
  },
  async getCourseSessions({ queryParameters = {}, expand = [] } = {}) {
    return (
      await request({
        url: 'course_sessions',
        queryParameters,
        expand,
      })
    ).data
  },
  async checkRegistrationEligibility({ data = {} }) {
    return (
      await request({
        method: 'POST',
        url: 'registration_eligibility/check',
        data,
      })
    ).data
  },
  async getRedirectUrlFromNotAuthModal({ queryParameters = {} }) {
    return (
      await request({
        url: 'check_account',
        queryParameters,
      })
    ).data
  },
  async getUsesFromCustomerMembershipId({
    queryParameters = {},
    customerMembershipId,
  }) {
    if (!customerMembershipId) {
      console.warn(
        'API: getUsesFromCustomerMembershipId: customerMembershipId is not defined!',
      )
      return
    }
    return (
      await request({
        url: `customer_memberships/${customerMembershipId}/usage`,
        queryParameters,
      })
    ).data
  },
  async joinWaitlist(eventId, { data = {} }) {
    return (
      await request({
        method: 'POST',
        url: `/events/${eventId}/join_waitlist`,
        data,
      })
    ).data
  },
  async leaveWaitlist(eventId, { data = {} }) {
    return (
      await request({
        method: 'POST',
        url: `/events/${eventId}/leave_waitlist`,
        data,
      })
    ).data
  },

  async unregister(eventId) {
    return (
      await request({
        method: 'POST',
        url: `/events/${eventId}/unregister`,
      })
    ).data
  },

  async createEventOnlineAccessLink(eventId, { data = {} }) {
    return (
      await request({
        method: 'POST',
        url: `/events/${eventId}/generate_online_access_link`,
        data,
      })
    ).data
  },
  async getBusinessClosures({ queryParameters = {} } = {}) {
    return (
      await request({ url: 'business_closures', queryParameters })
    ).data
  },
}
